import { Avatar, AvatarProps } from 'antd';
import noAvatarImage from 'assets/noAvatar.svg';
import { getInitials } from 'utils/utils';

interface UserAvatarProps extends AvatarProps {
  user?: {
    avatarUrl?: string | null;
    firstName?: string;
    lastName?: string;
  } | null;
  fallbackType?: 'initials' | 'default';
}

const UserAvatar = ({ user, className, shape = 'circle', fallbackType = 'default', ...rest }: UserAvatarProps) => {
  const initials = getInitials(user?.firstName, user?.lastName);
  const showInitials = fallbackType === 'initials' && !!initials;

  return (
    <Avatar
      src={user?.avatarUrl ? user.avatarUrl : showInitials ? undefined : noAvatarImage}
      className={className || 'avatar'}
      shape={shape}
      {...rest}
      style={{
        ...rest.style,
        minWidth: typeof rest.size === 'number' ? `${rest.size}px` : undefined,
        minHeight: typeof rest.size === 'number' ? `${rest.size}px` : undefined
      }}
    >
      {!user?.avatarUrl && showInitials && initials}
    </Avatar>
  );
};

export default UserAvatar;
